import React, { Component } from 'react'
import _ from 'lodash'
import { ApiDocs, Seo } from '../components'
import { GlobalStyle } from '../styles/global'
import { resolveOpenApiRef, getOpenApiPath, compileTemplate } from '../util'
import content from '../content.json'

// Do only once
_.forEach(content.templates, (text, key) => {
  // This check safe-guards that this module can be loaded multiple times.
  // In production env it shouldn't happen but will happen in local hot reloads
  if (_.isString(text)) {
    content.templates[key] = compileTemplate(text)
  }
})

class IndexPage extends Component {
  shouldComponentUpdate() {
    // TODO: Fix this properly. Currently we don't have any state changes after first render,
    //       so we don't need to update the components at all. When we do have changes,
    //       this needs to be fixed
    if (process.env.NODE_ENV === 'production') {
      return false
    }

    return true
  }

  render() {
    const bundle = content.openapi
    const openapi = {
      resolveRef: (obj) => resolveOpenApiRef(bundle, obj),
      getPath: (apiObj, attrs) => getOpenApiPath(bundle, apiObj, attrs),
      bundle,
    }

    return (
      <div className="IndexPage">
        <GlobalStyle />
        <Seo title="Aito.ai" keywords={['aito', 'api', 'docs', 'documentation', 'ai', 'machine', 'learning']} />
        <ApiDocs content={content} openapi={openapi} />
      </div>
    )
  }
}

export default IndexPage
